export default __webpack_public_path__ + "static/media/corporate12.1e1a18cb.webp";